import { memo } from "react";
import { Flex } from "../flex";
import { Text } from "../text";
import { RedoCheckbox } from "./redo-checkbox";

export interface RedoCheckboxAdvancedProps {
  "data-dd-action-name"?: string;
  title: React.ReactNode;
  children?: React.ReactNode;
  rightContent: React.ReactNode;
  checked: boolean;
  onClick?: () => void;
  showBorder?: boolean;
  disabled?: boolean;
  "data-testid"?: string;
}

export const RedoCheckboxAdvanced = memo(
  function RedoCheckboxCardAdvancedProps({
    title,
    checked,
    onClick,
    children,
    rightContent,
    showBorder = false,
    disabled = false,
    "data-testid": dataTestId,
    "data-dd-action-name": actionName,
  }: RedoCheckboxAdvancedProps) {
    return (
      <Flex
        align="center"
        bgColor={showBorder ? "primary" : undefined}
        borderColor={showBorder ? "primary" : undefined}
        borderRadius={showBorder ? "lg" : undefined}
        borderWidth={showBorder ? "1px" : undefined}
        data-arbiter="RedoCheckboxAdvanced"
        data-dd-action-name={actionName}
        data-testid={dataTestId}
        justify="space-between"
        p={showBorder ? "lg" : undefined}
      >
        <Flex gap="lg">
          <Flex align="center" justify="center">
            <RedoCheckbox
              ariaLabel={typeof title === "string" ? title : undefined}
              data-dd-action-name={actionName}
              disabled={disabled}
              label=""
              setValue={onClick ?? (() => {})}
              value={checked}
            />
          </Flex>
          <Flex align="flex-start" dir="column" flex={1} gap="xs">
            <Text fontSize="xs" fontWeight="bold">
              {title}
            </Text>
            <Text fontSize="xxs" textColor="secondary">
              {children}
            </Text>
          </Flex>
        </Flex>
        {rightContent}
      </Flex>
    );
  },
);
